module.exports = __webpack_public_path__ + "static/19-1-261190da648db701b3bfdaf5b1a317c2.jpg";